import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../../layout/breadcrumb";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import CommonDataTable from "../../../share-components/table/commonDataTable";
import { useDispatch } from "react-redux";
import withReducer from "../../../store/withReducer";
import productReducer from "../../manage-product/store";
import { exportDataQualityAlertsApi } from "../../../services/manage-product/productService";
import { getDataQualityAlerts } from "../../manage-product/store/prodcutSlice";
import { toast } from "react-toastify";
import PreLoader from "../../../share-components/ui/preLoader";

const dataMenu = [
  {
    type: 0,
    text: "Data Quality Alerts",
  },
];

const formatPrice = (value) =>
  value === null || value === undefined || value === "" ? "-" : `£${parseFloat(value).toFixed(2)}`;

const missingImagesColumns = [
  { name: "Style", selector: (row) => row.code || "-", sortable: true, minWidth: "150px" },
  { name: "Title", selector: (row) => row.name || "-", sortable: true, wrap: true, grow: 3 },
  { name: "Status", selector: (row) => row.status || "-", center: true, minWidth: "120px" },
];

const belowCostColumns = [
  { name: "Style", selector: (row) => row.code || "-", sortable: true, minWidth: "150px" },
  { name: "Title", selector: (row) => row.name || "-", sortable: true, wrap: true, grow: 3 },
  { name: "Price", selector: (row) => formatPrice(row.price), right: true, minWidth: "100px" },
  { name: "Sale Price", selector: (row) => formatPrice(row.sale_price), right: true, minWidth: "100px" },
  { name: "Cost Per Item", selector: (row) => formatPrice(row.cost_per_item_price), right: true, minWidth: "120px" },
];

const DataQualityAlerts = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [missingImages, setMissingImages] = useState([]);
  const [belowCost, setBelowCost] = useState([]);

  const fetchAlerts = () => {
    setLoading(true);
    dispatch(getDataQualityAlerts({}))
      .then((res) => {
        setMissingImages(res.payload?.missing_images || []);
        setBelowCost(res.payload?.below_cost || []);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data quality alerts:", error);
        setMissingImages([]);
        setBelowCost([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  const handleExport = async () => {
    try {
      setExportLoading(true);
      const { response } = await exportDataQualityAlertsApi({});

      const isBlobResponse = response instanceof Blob;
      const blobData = isBlobResponse ? response : response?.data;
      const contentType = isBlobResponse
        ? response?.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        : response?.headers?.['content-type']
          || response?.headers?.get?.('content-type')
          || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const blob = new Blob([blobData ?? ''], {
        type: contentType,
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'product-data-quality-alerts.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      let message = 'Failed to export data quality alerts';
      try {
        if (error?.response?.data instanceof Blob) {
          const parsed = JSON.parse(await error.response.data.text());
          if (parsed?.message) {
            message = parsed.message;
          }
        } else if (error?.response?.data?.message) {
          message = error.response.data.message;
        }
      } catch (e) {
        // swallow parse errors, keep default message
      }

      toast.error(message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setExportLoading(false);
    }
  };

  const hasData = missingImages.length > 0 || belowCost.length > 0;

  return (
    <Fragment>
      <Breadcrumb title="Data Quality Alerts" data={dataMenu} />
      <Container fluid={true} className="product-wrapper">
        <Row className="mb-3">
          <Col sm="12" className="d-flex justify-content-end">
            <Button
              color="primary"
              className="btn btn-square"
              disabled={exportLoading || loading || !hasData}
              onClick={handleExport}
            >
              {exportLoading ? (
                <i className="fa fa-spinner fa-spin fa-lg spinner mr-1" />
              ) : (
                'Export Excel'
              )}
            </Button>
          </Col>
        </Row>
        {loading ? (
          <div style={{ minHeight: 150 }}>
            <PreLoader />
          </div>
        ) : (
          <>
            <Card>
              <CardBody>
                <h5 className="mb-3">Live Products Missing Images ({missingImages.length})</h5>
                <CommonDataTable
                  headerColumns={missingImagesColumns}
                  gridData={missingImages}
                  noAction
                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                />
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <h5 className="mb-3">Live Products Priced Below Cost ({belowCost.length})</h5>
                <CommonDataTable
                  headerColumns={belowCostColumns}
                  gridData={belowCost}
                  noAction
                  paginationRowsPerPageOptions={[10, 25, 50, 100]}
                />
              </CardBody>
            </Card>
          </>
        )}
      </Container>
    </Fragment>
  );
};

export default withReducer([{ product: productReducer }])(DataQualityAlerts);
